import React from "react";
import { Container, Breadcrumb, BreadcrumbItem, Jumbotron } from "reactstrap";
import { Link } from "react-router-dom";
import { compose } from "redux";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

import { ChangeLanguage } from "./ChangeLanguage";

class Settings extends React.Component<any, any> {
  render() {
    const { authentication, t } = this.props;

    // if (authentication) console.log(authentication);

    return (
      <Container className="settings">
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/">Sypal</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>{t("settings")}</BreadcrumbItem>
        </Breadcrumb>
        <ChangeLanguage />

        <Jumbotron
          style={{
            backgroundColor: "white",
            border: "1px solid rgba(0, 0, 0, 0.125)"
          }}
        >
          {t("roles")} :
          <br />
          {authentication &&
            (authentication.user &&
              (authentication.user.roles &&
                authentication.user.roles.map((role: any) => role)))}
        </Jumbotron>

        {/* <ChangePassword />
      <UserManagement /> */}
      </Container>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    authentication: state.authentication
  };
};

const SettingComponent = compose(
    withTranslation('settings'),
    connect(mapStateToProps)
  )(Settings);

export { SettingComponent as Settings };
